<template>
  <div>
    <button
      class="button"
      type="button"
      @click="openDialog"
    >
      <span
        v-if="$props.error"
        class="error"
      >Value is required</span>

      <span class="title">{{ label }}:</span>
      <span>{{ value.en }}</span>

      <div class="translations">
        <div
          v-for="locale in localeListWOEnglish"
          :key="locale"
          class="entry"
        >
          <span class="entryLabel">{{ localeCodeToLabel[locale] }}:</span>
          <span class="entryValue">{{ value[locale] || '-' }}</span>
        </div>
      </div>
    </button>

    <md-dialog :md-active.sync="dialog.isOpen">
      <md-dialog-title>{{ label }}</md-dialog-title>

      <md-dialog-content>
        <md-field
          v-for="locale in localeList"
          :key="locale"
          class="dialogField"
        >
          <label>{{ localeCodeToLabel[locale] }}</label>
          <md-input v-model="dialog.data[locale]" />
        </md-field>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button
          @click="dialog.isOpen = false"
        >
          Close
        </md-button>
        <md-button
          class="md-primary"
          @click="saveChanges"
        >
          Save
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
  import { LOCALES_LIST, localeCodeToLabel } from "@/utils/currentLocalesList";

  export default {
    props: {
      value: { type: Object, required: true },
      label: { type: String, required: true },
      erorr: { type: Boolean, required: false, default: false }
    },
    data() {
      return {
        localeList: [...LOCALES_LIST],
        localeListWOEnglish: [...LOCALES_LIST].splice(1),
        localeCodeToLabel,

        dialog: {
          isOpen: false,
          data: {}
        },
      };
    },
    methods: {
      openDialog() {
        this.dialog.data = { ...this.$props.value };
        this.localeList.forEach(locale => {
          if (!this.dialog.data[locale]) {
            this.dialog.data[locale] = "";
          }
        });

        this.dialog.isOpen = true;
      },
      saveChanges() {
        // filter out empty entries
        for (const locale of LOCALES_LIST) {
          if (!this.dialog.data[locale]) {
            delete this.dialog.data[locale];
          }
        }

        this.$emit("input", this.dialog.data);
        this.dialog.isOpen = false;
      }
    }
  };
</script>

<style scoped lang="scss">
  .button {
    all: unset;
    cursor: pointer;

    margin: 0 0 24px;
  }

  .title {
    font-weight: 700;
    font-size: 16px;

    padding-right: 4px;
  }

  .translations {
    display: flex;
    flex-wrap: wrap;
    column-gap: 4px;
  }

  .entry {
    font-size: 13px;

    &Label {
      font-weight: 700;
      padding-right: 2px;
    }
  }

  .dialogField {
    max-width: 500px;
  }

  .error {
    color: red;
    font-weight: 700;
  }
</style>
